import { EpimsBaseEntityDto } from './epim-base.dto';
export class CompanyDto extends EpimsBaseEntityDto {
  CompanyName: string;
  CompanyId: string;
  SubscriptionUserId: string;
  Version: number;
}
